module.exports = __webpack_public_path__ + "img/sv77.483a42b5.svg";